import { render, staticRenderFns } from "./RatingTag.vue?vue&type=template&id=7c89f242&scoped=true"
import script from "./RatingTag.vue?vue&type=script&lang=js"
export * from "./RatingTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89f242",
  null
  
)

export default component.exports